import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";

export default function AdminCms() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [form, setForm] = useState({ title: "", html: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/cms").then((r) => {
      const pages = r.data.items || [];
      setItems(pages);
      if (pages.length > 0 && !active) {
        setActive(pages[0].slug);
        setForm({ title: pages[0].title, html: pages[0].html });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pick = async (slug) => {
    const { data } = await api.get(`/admin/cms/${slug}`);
    setActive(slug);
    setForm({ title: data.title, html: data.html });
  };

  const save = async () => {
    setBusy(true);
    try {
      await api.patch(`/admin/cms/${active}`, form);
      toast.success("Saved.");
    } catch (e) {
      toast.error("Save failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5" data-testid="admin-cms">
      <div>
        <span className="label-overline text-jow-gold">Storefront pages</span>
        <h1 className="font-display text-3xl text-jow-navy mt-1">CMS</h1>
      </div>

      <div className="grid md:grid-cols-4 gap-5">
        <aside className="md:col-span-1 bg-white border border-jow-navy/10 p-3">
          <p className="label-overline text-jow-navy mb-2 px-1">Pages</p>
          <ul className="space-y-1">
            {items.map((p) => (
              <li key={p.slug}>
                <button
                  onClick={() => pick(p.slug)}
                  className={`w-full text-left px-3 py-2 text-sm ${
                    active === p.slug
                      ? "bg-jow-navy text-jow-cream"
                      : "text-jow-navy/70 hover:bg-jow-cream/60"
                  }`}
                  data-testid={`cms-pick-${p.slug}`}
                >
                  <span className="font-display">{p.title}</span>
                  <br />
                  <span className="text-[10px] uppercase tracking-widest opacity-60">/{p.slug}</span>
                </button>
              </li>
            ))}
          </ul>
        </aside>

        <div className="md:col-span-3 space-y-3">
          {active && (
            <>
              <div>
                <label className="label-overline block mb-1">Title</label>
                <input
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                  className="w-full border border-jow-navy/15 px-3 py-2 text-sm bg-white"
                  data-testid="cms-title"
                />
              </div>
              <div className="grid md:grid-cols-2 gap-3">
                <div>
                  <label className="label-overline block mb-1">HTML</label>
                  <textarea
                    rows={18}
                    value={form.html}
                    onChange={(e) => setForm({ ...form, html: e.target.value })}
                    className="w-full border border-jow-navy/15 px-3 py-2 text-xs font-mono bg-white"
                    data-testid="cms-html"
                  />
                </div>
                <div>
                  <label className="label-overline block mb-1">Preview</label>
                  <div
                    className="border border-jow-navy/15 px-4 py-3 bg-white min-h-[18rem] text-sm text-jow-navy prose prose-sm max-w-none"
                    dangerouslySetInnerHTML={{ __html: form.html }}
                    data-testid="cms-preview"
                  />
                </div>
              </div>
              <button
                onClick={save}
                disabled={busy}
                className="btn-primary-jow"
                data-testid="cms-save"
              >
                <Save size={13} /> {busy ? "Saving…" : "Save changes"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
